
export enum ECoreRoutes {
  ERROR_403 = 'Core.403',
  ERROR_404 = 'Core.404',
  ERROR_500 = 'Core.500'
}
